import { createAction, props } from '@ngrx/store';

export const isLoading = createAction('[UI Component] Is Loading');
export const stopLoading = createAction('[UI Component] Stop Loading');

export const setLogo = createAction(
    '[UI Component] Set Logo',
    props<{companyImg: string}>()
);